export default "__VITE_ASSET__g0_bm087__"